import { FormikHelpers } from 'formik';
import React, { FC } from 'react';
import Toggle from '../../../../library/inputs/toggle/Toggle';

/*
 ** Component: ToggleField
 ** Props
 ** id: field id
 ** enabled: control disabled or not
 ** value: field value
 ** label: label of the checkbox
 ** setFieldValue: function to handle formik value
 */

interface Props {
  id: string;
  enabled: boolean;
  value: boolean;
  label: React.ReactNode;
  setFieldValue: FormikHelpers<string>['setFieldValue'];
  setFieldTouched: FormikHelpers<string>['setFieldTouched'];
  readOnlyMode?: boolean;
}

const ToggleField: FC<Props> = ({ id, enabled, value, label, setFieldValue, setFieldTouched, readOnlyMode }: Props) => {
  return (
    <Toggle
      id={id}
      disabled={!enabled}
      checked={value}
      label={label}
      onChange={async (val) => {
        await setFieldValue(id, val.target.checked, true);
        await setFieldTouched(id, true, true);
      }}
      readOnlyMode={readOnlyMode}
    />
  );
};

export default ToggleField;
